import { FFH_SERVICE_INT } from '@hub/free-form-hub/config';

export type NbsResponse = {
  category: string;
  oroox_id: string;
  dimensions?: Record<string, number>;
  request_id?: string;
};

export const fetchNbsRecommendation = async (fileId: string): Promise<NbsResponse | null> => {
  const response = await fetch(`${FFH_SERVICE_INT}/nbs/${fileId}`, {
    method: 'GET',
  });

  if (response.ok) {
    return (await response.json()) as NbsResponse;
  }

  throw new Error(`Failed to fetch NBS recommendation: ${response.status} ${response.statusText}`);
};
